import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import Container from './../Container';
import Image from 'partials/Image';
import SmartLink from 'partials/SmartLink';
import WP from 'WP';
import api from 'api';
import css from 'css';

class Contact extends Component {

    constructor() {
        super();

        this.state = {
            contactPoint: null,
        }
    }

    _renderMapSection(data, city) {
        const mapURL = 'https://www.google.com/maps/place/'+data[city+'_address'].replace('<br />', '').replace(/\s+/g, '+').replace(/\r?\n|\r/g, '');
        return (
            <MapSection>
                <div>
                    {data[city+'_map'].ID && 
                        <a href={mapURL} target="_blank">
                            <Image image={data[city+'_map']} />
                        </a>
                    }
                    <div className="details">
                        <strong>{city.charAt(0).toUpperCase()+city.slice(1)}</strong>
                        <div>
                            <address dangerouslySetInnerHTML={{ __html: data[city+'_address'] }} />
                            <div>
                                <a href={'tel:'+data[city+'_phone'].replace(' ','')}>{data[city+'_phone']}</a>
                                <br/>
                                <a href={'mailto:'+data[city+'_email']}>{data[city+'_email']}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </MapSection>
        )
    }

    _renderContactPerson(data) {
        const contactPoint = this.state.contactPoint;
        if(contactPoint) {
            return (
                <Employee>
                    <figure className="image">
                        <Image image={contactPoint.acf.image} background ratio="3:3.5" />
                    </figure>
                    <div className="details">
                        <div>{contactPoint.title.rendered}</div>
                        <div>{contactPoint.acf.job_title}</div>
                        {contactPoint.acf.phone &&
                            <div>
                                <a href={'tel:'+contactPoint.acf.phone.replace(' ','')}>{contactPoint.acf.phone}</a>
                            </div>
                        }
                        {contactPoint.acf.twitter &&
                            <div>
                                <a href={'https://twitter.com/'+contactPoint.acf.twitter} target="_blank">Twitter</a>
                            </div>
                        }
                        {contactPoint.acf.linkedin &&
                            <div>
                                <a href={contactPoint.acf.linkedin} target="_blank">Linkedin</a>
                            </div>
                        }
                    </div>
                </Employee>
            )
        }

        api.getEmployee(data.ID)
            .then(resp => this.setState({ contactPoint: resp.data }) );
    }

    render() {
        const { data } = this.props;

        //console.log('CONTACT:', data);

        return(
            <ModuleWrapper background={data.background}>
                <Container>
                    <ModuleContent>

                        <Left>
                            <h3>{WP.trans.contact || 'Kontakt'}</h3>

                            <MainContactPoint>
                                <address>{data.main_address}</address>
                                <p>
                                    <a href={'tel:'+data.main_phone_number.replace(' ','')}>{data.main_phone_number}</a>
                                </p>
                                <p>
                                    <a href={'mailto:'+data.main_email}>{data.main_email}</a>
                                </p>
                            </MainContactPoint>

                            {data.contact_person.ID &&
                                this._renderContactPerson.bind(this)(data.contact_person)
                            }

                            <Description dangerouslySetInnerHTML={{ __html: data.description }}/>

                            <ArchiveLink to={WP.lang === 'no' ? '/folk' : '/people'}>{WP.trans.seeAllEmployees || 'Se alle folk'} </ArchiveLink>
                        </Left>

                        <Right>
                            {this._renderMapSection(data, 'bergen')}
                            {this._renderMapSection(data, 'voss')}
                        </Right>
                    </ModuleContent>
                </Container>
            </ModuleWrapper>
        );
    }
}

export default withRouter(Contact);

const ModuleWrapper = styled.div`
    background-color: ${props => props.background === 'white' ? '#fff' : css.colors.gray};
    padding:120px 0;
    @media (max-width:768px) {
        padding:50px 0;
    }
`

const ModuleContent = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`

const Left = styled.div`
    width: 30%;
    @media (max-width:768px) {
        width: 100%;
    }
    h3 {
        font-size:43px;
        font-family: ${css.fonts.bg_bold};
        margin-bottom:30px;
        @media (max-width:768px) {
            font-size:30px;
        }
        @media (max-width:480px) {
            font-size: 26px;
            line-height: 31px;
        }
    }    
`

const MainContactPoint = styled.div`
    margin-bottom:40px;
    p, address {
        margin-bottom: 10px;
        font-size:18px;
        font-family: ${css.fonts.bg_regular};
        @media (max-width:768px) {
            font-size:16px;
        }
        a {
            font-family: ${css.fonts.bg_regular};
        }
    }
`

const Employee = styled.div`
    margin-bottom: 60px;
    display: flex;
    flex-wrap:wrap;
    @media (max-width: 480px) {
        margin-bottom: 30px;
    }
    .image {
        max-width: 40%;
        width:100%;
        margin-right:45px;
        @media (max-width:768px) {
            margin-right:20px;
        }
    }
    .details {
        display:flex;
        flex-direction:column;
        justify-content:flex-end;
        padding-top:20px;
        div, a {
            display:inline-block;
            margin-bottom: 10px;
            font-size:18px;
            font-family: ${css.fonts.bg_regular};
            @media (max-width:768px) {
                font-size:16px;
            }
        }
        a {
            padding-bottom:2px;
            &:hover {
                border-bottom: 1px solid transparent;
            }
        }
        div:last-child {
            margin-bottom:0;
        }
        a:last-child {
            margin-bottom:0;
        }
    }
`

const Description = styled.p`
    font-size: 24px;
    margin-bottom: 100px;
    font-family: ${css.fonts.bg_regular};
    @media (max-width:768px) {
        font-size:16px;
        margin-bottom:60px;
    }
    @media (max-width: 480px) {
        margin-bottom: 30px;
    }
`

const ArchiveLink = styled(SmartLink)`
    font-size:18px;
`

const Right = styled.div`
    width: ${css.sizes.rightColumn};

    @media (max-width:768px) {
        width: 100%;
        padding-top:40px;
    }
`

const MapSection = styled.div`
    margin-bottom:40px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    @media (max-width:768px) {
        align-items: flex-start;
        &:last-child {
            margin-bottom:0;
        }
    }
    .details {
        padding-top:25px;
        display:flex;
        align-items: flex-start;
        > div {
            display:flex;
            @media (max-width:768px) {
                flex-direction: column;
                address {
                    margin-bottom: 20px;
                }
            }
        }
        strong, address, > div > div {
            margin-right: 40px;
        }
        strong {
            font-size:16px;
            font-family: ${css.fonts.bg_medium};
            font-weight:normal;
            margin-top: -1px;
            @media (max-width:768px) {
                width:120px;
                margin-right:0;
            }
        }
        > div > div {
            margin-top: -1px;
        }
        address, a {
            color: #797979;
            font-size:14px;
            font-family: ${css.fonts.bg_regular};
            line-height:1.5;
        }
        a {
            line-height:1.3;
            border-bottom-color: #9e9e9e;
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/Contact.js